/**
 * The icon set, assembled by hand.
 *
 * The design system's Icon component looks names up in `window.lucide.icons`.
 * Importing lucide's barrel would pull in all ~1743 icons and add roughly
 * 700 kB for the few dozen this app uses, so each is imported individually and
 * the lookup table is built here — same approach as website-main.
 *
 * Icon renders `icons[pascal(name)] || icons[name]`, so keys are PascalCase.
 * A missing entry renders nothing at all rather than throwing, so grep this
 * file first if an icon goes blank.
 */

import {
  AlertTriangle,
  ArrowLeft,
  ArrowUpDown,
  Bell,
  Briefcase,
  Building2,
  Check,
  ChevronDown,
  ChevronRight,
  Clock,
  Copy,
  Crosshair,
  Crop,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  FileArchive,
  FileText,
  Folder,
  FolderPlus,
  FolderUp,
  Gem,
  GraduationCap,
  HardDrive,
  History,
  Image,
  Inbox,
  Info,
  Key,
  Layers,
  LayoutGrid,
  Link2,
  List,
  ListChecks,
  Lock,
  LogOut,
  Mail,
  MessageCircle,
  MessageSquare,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  PanelLeftClose,
  PanelLeftOpen,
  Plus,
  RefreshCw,
  RotateCcw,
  ScrollText,
  Search,
  Share2,
  Shield,
  ShieldCheck,
  Sun,
  Trash2,
  Unlock,
  Upload,
  UploadCloud,
  User,
  UserPlus,
  Users,
  Video,
  X
} from 'lucide';

export const iconSet = {
  AlertTriangle,
  ArrowLeft,
  ArrowUpDown,
  Bell,
  Briefcase,
  Building2,
  Check,
  ChevronDown,
  ChevronRight,
  Clock,
  Copy,
  Crosshair,
  Crop,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  FileArchive,
  FileText,
  Folder,
  FolderPlus,
  FolderUp,
  Gem,
  GraduationCap,
  HardDrive,
  History,
  Image,
  Inbox,
  Info,
  Key,
  Layers,
  LayoutGrid,
  Link2,
  List,
  ListChecks,
  Lock,
  LogOut,
  Mail,
  MessageCircle,
  MessageSquare,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  PanelLeftClose,
  PanelLeftOpen,
  Plus,
  RefreshCw,
  RotateCcw,
  ScrollText,
  Search,
  Share2,
  Shield,
  ShieldCheck,
  Sun,
  Trash2,
  Unlock,
  Upload,
  UploadCloud,
  User,
  UserPlus,
  Users,
  Video,
  X
};
